(() => {
  if (window.sosanovaFloatingProducts) return;
  window.sosanovaFloatingProducts = true;
  const seen = new WeakSet();
  const selector = '.phase-archive__media img, .cart-item__media img, .product-card-wrapper .card__media img, .product__media-wrapper .product__media img, .product__media-wrapper .thumbnail img, product-modal .product-media-modal__content img';
  const cache = new Map();
  const cutout = (url) => {
    if (cache.has(url)) return cache.get(url);
    const job = new Promise((resolve) => {
      const source = new Image();
      source.crossOrigin = 'anonymous';
      source.onload = () => {
        try {
          const scale = Math.min(1, 1024 / Math.max(source.naturalWidth, source.naturalHeight));
          const width = Math.max(1, Math.round(source.naturalWidth * scale));
          const height = Math.max(1, Math.round(source.naturalHeight * scale));
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d', {willReadFrequently: true});
          ctx.drawImage(source, 0, 0, width, height);
          const pixels = ctx.getImageData(0, 0, width, height);
          const data = pixels.data;
          const corners = [0, width - 1, (height - 1) * width, width * height - 1];
          if (corners.some(p => data[p * 4 + 3] < 250)) return resolve(null);
          const colors = corners.map(p => Array.from(data.slice(p * 4, p * 4 + 3)));
          if (colors.some(c => Math.min(...c) < 210 || Math.max(...c) - Math.min(...c) > 20)) return resolve(null);
          const bg = [0,1,2].map(channel => colors.reduce((sum,c) => sum + c[channel],0) / 4);
          if (colors.some(c => c.some((v,i) => Math.abs(v - bg[i]) > 16))) return resolve(null);
          const count = width * height;
          const visited = new Uint8Array(count);
          const queue = new Uint32Array(count);
          let head = 0, tail = 0;
          const add = p => {
            if (visited[p]) return;
            visited[p] = 1;
            const i = p * 4;
            if (data[i+3] < 16 || (Math.min(data[i],data[i+1],data[i+2]) > 190 &&
              Math.max(data[i],data[i+1],data[i+2]) - Math.min(data[i],data[i+1],data[i+2]) < 25 &&
              Math.max(Math.abs(data[i]-bg[0]),Math.abs(data[i+1]-bg[1]),Math.abs(data[i+2]-bg[2])) < 42)) queue[tail++] = p;
          };
          for (let x=0;x<width;x++) {add(x);add((height-1)*width+x);}
          for (let y=0;y<height;y++) {add(y*width);add(y*width+width-1);}
          while (head < tail) {
            const p = queue[head++];
            data[p*4+3] = 0;
            const x=p%width;
            if(x>0) add(p-1);
            if(x<width-1) add(p+1);
            if(p>=width) add(p-width);
            if(p<count-width) add(p+width);
          }
          if (tail / count < .08 || tail / count > .96) return resolve(null);
          const distance = new Uint8Array(count);
          distance.fill(255);
          for (let n=0;n<tail;n++) distance[queue[n]] = 0;
          head = 0;
          while (head < tail) {
            const p = queue[head++];
            if (distance[p] >= 3) continue;
            const x = p % width, y = Math.floor(p / width);
            for (let dy=-1;dy<=1;dy++) for (let dx=-1;dx<=1;dx++) {
              if ((!dx && !dy) || x+dx<0 || x+dx>=width || y+dy<0 || y+dy>=height) continue;
              const neighbor = p + dy*width + dx;
              if (distance[neighbor] !== 255) continue;
              distance[neighbor] = distance[p] + 1;
              queue[tail++] = neighbor;
            }
          }
          for (let p=0;p<count;p++) {
            if (distance[p] < 1 || distance[p] > 2) continue;
            const x = p % width, y = Math.floor(p / width);
            let reference = -1, nearest = Infinity;
            for (let dy=-4;dy<=4;dy++) for (let dx=-4;dx<=4;dx++) {
              if (x+dx<0 || x+dx>=width || y+dy<0 || y+dy>=height) continue;
              const candidate = p + dy*width + dx;
              const separation = dx*dx + dy*dy;
              if (distance[candidate] >= 3 && data[candidate*4+3] &&
                separation < nearest) {reference = candidate; nearest = separation;}
            }
            if (reference < 0) continue;
            const i=p*4, r=reference*4;
            let numerator=0, denominator=0;
            for (let channel=0;channel<3;channel++) {
              const delta = bg[channel] - data[r+channel];
              numerator += (bg[channel] - data[i+channel]) * delta;
              denominator += delta * delta;
            }
            if (denominator < 1200) continue;
            const alpha = Math.max(0, Math.min(1, numerator / denominator));
            if (alpha >= .98) continue;
            if (alpha < .25) {data[i+3]=0; continue;}
            for (let channel=0;channel<3;channel++) {
              data[i+channel] = Math.max(0, Math.min(255,
                (data[i+channel] - (1-alpha)*bg[channel]) / alpha));
            }
            data[i+3] = Math.round(data[i+3] * alpha);
          }
          ctx.putImageData(pixels,0,0);
          resolve(canvas.toDataURL('image/png'));
        } catch (_) {resolve(null);}
      };
      source.onerror = () => resolve(null);
      source.src = url;
    });
    cache.set(url,job);
    return job;
  };
  const process = async img => {
    const url = img.currentSrc || img.src;
    if (!url) return;
    const result = await cutout(url);
    if (!result || !img.isConnected) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = result;
    img.dataset.sosanovaCutout = 'true';
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      const img = entry.target;
      if (img.complete && img.naturalWidth) process(img);
      else img.addEventListener('load', () => process(img), {once:true});
    });
  }, {rootMargin:'200px'}) : null;
  const scan = root => root.querySelectorAll(selector).forEach(img => {
    if (seen.has(img)) return;
    seen.add(img);
    if(observer) observer.observe(img);
    else if(img.complete && img.naturalWidth) process(img);
    else img.addEventListener('load', () => process(img), {once:true});
  });
  scan(document);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1) scan(node);
    }));
  }).observe(document.body,{childList:true,subtree:true});
})();
